import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { FiltroPesquisaService } from '../../_services/filtroPesquisa.service';
import { PopupMessagesComponent } from '../popup-messages/popup-messages.component';
import { UsuariosResponsaveisService } from '../../_services';
import { Responsavel, Filtro, FiltroItem, Message } from '../../_models';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
  selector: 'popup-filtro-pesquisa',
  templateUrl: './popup-filtro-pesquisa.component.html',
  styleUrls: ['./popup-filtro-pesquisa.component.css']
})
export class PopupFiltroPesquisaComponent implements OnInit {
  tipoColetor: string;
  CentroCustos: boolean;
  DiagramaRede: boolean;
  OrdemInterna: boolean;
  loading = false;
  loadListaFiltros = true;
  loadListaFiltrosEdit = false;
  messageModel: Message;
  idEditFiltro: number;
  lstFiltro = new Array<Filtro>();
  lstFiltroItemEditar = new Array<FiltroItem>();
  lstFiltroItemExcluidos = new Array<FiltroItem>();
  lstFiltroItemCriar = new Array<FiltroItem>();
  disabledYN: boolean;
  selectedTab: number;
  public responsaveis: Responsavel[];
  FiltroForm: FormGroup;
  FiltroEditForm: FormGroup;
  filtro = new Filtro();
  filtroItem = new FiltroItem();
  filtroItemCriar = new FiltroItem();
  filtroItemEdit = new FiltroItem();

  constructor(
    private formBuilder: FormBuilder,
    private apiFiltroPesquisa: FiltroPesquisaService,
    private apiResponsaveis: UsuariosResponsaveisService,
    private dialogRef: MatDialogRef<PopupFiltroPesquisaComponent>,
    private dialog?: MatDialog
    ) { this.tipoColetor = JSON.parse(localStorage.getItem('tipoColetor')); }

  ngOnInit() {
    this.CarregarValidacoesTela();
    this.disabledYN = true;
    this.getResponsaveis();
    this.ListarFiltro();
  }

  CarregarValidacoesTela() {
    this.FiltroForm = this.formBuilder.group({
      frmNomeFiltro: ['', Validators.required],
      frmUsuarioCriacao: ['', Validators.required],
      frmResponsavel: ['', Validators.required]
    });

    this.FiltroEditForm = this.formBuilder.group({
      frmNomeFiltroEdit: ['', Validators.required],
      frmUsuarioCriacaoEdit: ['', Validators.required],
      frmResponsavelEdit: ['', Validators.required]
    });
  }

  applyFilter(filterValue: string) {
    this.dataSourceEdit.filter = filterValue.trim().toLowerCase();
  }

  ListarFiltro(){
    this.loadListaFiltros = true;
    this.apiFiltroPesquisa.ObterFiltros()
      .subscribe(
        rtn => this.lstFiltro = rtn.data,
        err => {
          this.loadListaFiltros = false;
          console.log(err);
          this.messageModel = new Message(
            "Filtros",
            "Erro de conexão",
            "Ocorreu um erro ao listar os filtros da base. Tente novamente.",
            "warning")

          this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        },
        () => {
          this.dataSource = new MatTableDataSource<Filtro>(this.lstFiltro);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.loadListaFiltros = false;
        }
      );
  }

  deleteFiltro(row){
    this.messageModel = new Message(
      "Meus Filtros",
      "Confirma a exclusão do filtro?",
      "",
      "confirm");

    let confirmDeleteFiltro = false;
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });

    dialogRef.afterClosed().subscribe(result => {
      confirmDeleteFiltro = result;

      if (confirmDeleteFiltro != null && confirmDeleteFiltro) {

        let result;
        console.log(row);
        this.apiFiltroPesquisa.ExcluirFiltro(row)
        .subscribe(
          rtn => result = rtn.data,
          err => {
            this.disabledYN = true;
            this.messageModel = new Message(
              "Itens Filtro",
              "Erro de conexão",
              "Ocorreu um erro ao excluir filtro na base de dados. Tente novamente.",
              "warning")

            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
          },
          () => {
            this.ListarFiltro();
            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "Filtro excluido com sucesso!", "", "warning") });
            this.selectedTab = 0;
          }
        );
      }
    });
  }

  ListarItemFiltro(idFiltro: number){
    this.loadListaFiltrosEdit = true;
    this.apiFiltroPesquisa.ObterFiltroItens(idFiltro)
      .subscribe(
        rtn => this.lstFiltroItemEditar = rtn.data,
        err => {
          this.loadListaFiltrosEdit = false;
          this.disabledYN = true;
          console.log(err);
          this.messageModel = new Message(
            "Protocolos",
            "Erro de conexão",
            "Ocorreu um erro ao listar os ultimos protocolos da base. Tente novamente.",
            "warning")

          this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        },
        () => {
          this.disabledYN = false;
          this.selectedTab = 2;
          this.dataSourceEdit = new MatTableDataSource<FiltroItem>(this.lstFiltroItemEditar);
          this.dataSourceEdit.paginator = this.paginator;
          this.dataSourceEdit.sort = this.sort;
          this.loadListaFiltrosEdit = false;
        }
      );
  }

  getResponsaveis() {
    this.apiResponsaveis.getResponsaveis()
      .subscribe(data => {
        this.responsaveis = data.data;
      });
  }

  AdicinarItem(){
    let usuarioCriacao = this.FiltroForm.controls['frmUsuarioCriacao'].value;
    let responsavel = this.FiltroForm.controls['frmResponsavel'].value;

    if(usuarioCriacao == null || usuarioCriacao == ''){
      this.FiltroForm.controls['frmUsuarioCriacao'].setValue('');
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "O campo Usuário Criação é obrigatório", "", "warning") });
    }
    else if(responsavel == null || responsavel == ''){
      this.FiltroForm.controls['frmResponsavel'].setValue(null);
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "O campo Responsável é obrigatório", "", "warning") });
    }
    else{
      this.filtroItemCriar = new FiltroItem();
      this.filtroItemCriar.usuarioCriacao = usuarioCriacao;
      this.filtroItemCriar.responsavel = responsavel;
      this.filtroItemEdit.idFiltroItens = 0;
      this.lstFiltroItemCriar.push(this.filtroItemCriar);

      this.FiltroForm.controls['frmUsuarioCriacao'].setValue('');
      this.FiltroForm.controls['frmResponsavel'].setValue(null);
      this.dataSourceCriar = new MatTableDataSource<FiltroItem>(this.lstFiltroItemCriar);
      this.dataSourceCriar.paginator = this.paginator;
      this.dataSourceCriar.sort = this.sort;
    }
  }

  deleteRowCriar(row) {
    let index = this.lstFiltroItemCriar.findIndex(d => d.usuarioCriacao.replace(' ', '') === row.usuarioCriacao.replace(' ', ''));
    this.lstFiltroItemCriar.splice(index, 1);
    this.dataSourceCriar = new MatTableDataSource<FiltroItem>(this.lstFiltroItemCriar);
  }

  EditarFiltro(idFiltro: number, nomeFiltro: string) {
    this.idEditFiltro = idFiltro;
    this.FiltroEditForm.controls['frmNomeFiltroEdit'].setValue(nomeFiltro);
    this.selectedTab = 0;
    this.lstFiltroItemExcluidos = [];
    this.ListarItemFiltro(idFiltro);
  }

  AdicinarItemEdit(){
    let usuarioCriacao = this.FiltroEditForm.controls['frmUsuarioCriacaoEdit'].value;
    let responsavel = this.FiltroEditForm.controls['frmResponsavelEdit'].value;

    if(usuarioCriacao == null || usuarioCriacao == ''){
      this.FiltroEditForm.controls['frmUsuarioCriacaoEdit'].setValue('');
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "O campo Usuário Criação é obrigatório", "", "warning") });
    }
    else if(responsavel == null || responsavel == ''){
      this.FiltroEditForm.controls['frmResponsavelEdit'].setValue(null);
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "O campo Responsável é obrigatório", "", "warning") });
    }
    else{
      this.filtroItemEdit = new FiltroItem();
      this.filtroItemEdit.usuarioCriacao = usuarioCriacao;
      this.filtroItemEdit.responsavel = responsavel;
      this.filtroItemEdit.idFiltroItens = 0;
      this.lstFiltroItemEditar.push(this.filtroItemEdit);

      this.FiltroEditForm.controls['frmUsuarioCriacaoEdit'].setValue('');
      this.FiltroEditForm.controls['frmResponsavelEdit'].setValue(null);
      this.dataSourceEdit = new MatTableDataSource<FiltroItem>(this.lstFiltroItemEditar);
      this.dataSourceEdit.paginator = this.paginator;
      this.dataSourceEdit.sort = this.sort;
    }
  }

  deleteRowEdicao(row) {
    let index = this.lstFiltroItemEditar.findIndex(d => d.usuarioCriacao.replace(' ', '') === row.usuarioCriacao.replace(' ', ''));
    this.lstFiltroItemEditar.splice(index, 1);
    this.dataSourceEdit = new MatTableDataSource<FiltroItem>(this.lstFiltroItemEditar);
    this.lstFiltroItemExcluidos.push(row);
  }

  Salvar(){
    let nomeFiltro = this.FiltroForm.controls['frmNomeFiltro'].value;

    if(nomeFiltro == '' || nomeFiltro == null){
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "O campo Nome Filtro é obrigatório", "", "warning") });
    }
    else if(this.lstFiltroItemCriar.length <= 0){
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "É obrigatório adicionar no mínimo um item.", "", "warning") });
    }
    else{
      this.loading = true;
      this.filtro.nomeFiltro = nomeFiltro;
      this.filtro.filtroItem = this.lstFiltroItemCriar;
      this.filtro.idFiltro = 0;
      this.apiFiltroPesquisa.CriarFiltro(this.filtro)
        .subscribe(
          rtn => this.lstFiltroItemEditar = rtn.data,
          err => {
            this.loading = false;
            this.disabledYN = true;
            this.messageModel = new Message(
              "Itens Filtro",
              "Erro de conexão",
              "Ocorreu um erro ao criar filtro na base de dados. Tente novamente.",
              "warning")

            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
          },
          () => {
            this.ListarFiltro();
            this.loading = false;
            this.FiltroForm.controls['frmNomeFiltro'].setValue('');
            this.FiltroForm.controls['frmUsuarioCriacao'].setValue('');
            this.FiltroForm.controls['frmResponsavel'].setValue(null);
            this.lstFiltroItemCriar = [];
            this.lstFiltroItemExcluidos = [];
            this.dataSourceCriar = new MatTableDataSource<FiltroItem>(null);
            this.selectedTab = 0;
            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "Filtro cadastrado com sucesso!", "", "warning") });
            this.selectedTab = 0;
          }
        );
    }
  }

  Editar(){
    let nomeFiltro = this.FiltroEditForm.controls['frmNomeFiltroEdit'].value;

    if(nomeFiltro == '' || nomeFiltro == null){
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "O campo Nome Filtro é obrigatório", "", "warning") });
    }
    else if(this.lstFiltroItemEditar.length <= 0){
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "É obrigatório adicionar no mínimo um item.", "", "warning") });
    }
    else{
      this.loading = true;
      this.filtro.nomeFiltro = nomeFiltro;
      this.filtro.filtroItem = this.lstFiltroItemEditar;
      this.filtro.idFiltro = this.idEditFiltro;
      this.filtro.filtroExcluir = this.lstFiltroItemExcluidos;
      this.apiFiltroPesquisa.AtualizarFiltro(this.filtro)
        .subscribe(
          rtn => this.lstFiltroItemEditar = rtn.data,
          err => {
            this.loading = false;
            this.disabledYN = true;
            this.messageModel = new Message(
              "Itens Filtro",
              "Erro de conexão",
              "Ocorreu um erro ao editar filtro na base de dados. Tente novamente.",
              "warning")

            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
          },
          () => {
            this.ListarFiltro();
            this.loading = false;
            this.FiltroEditForm.controls['frmNomeFiltroEdit'].setValue('');
            this.FiltroEditForm.controls['frmUsuarioCriacaoEdit'].setValue('');
            this.FiltroEditForm.controls['frmResponsavelEdit'].setValue(null);
            this.lstFiltroItemEditar = [];
            this.dataSourceEdit = new MatTableDataSource<FiltroItem>(null);
            this.lstFiltroItemExcluidos = [];
            this.selectedTab = 0;
            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: new Message("Itens Filtro", "Filtro atualizado com sucesso!", "", "warning") });
            this.selectedTab = 0;
          }
        );
    }
  }

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  displayedColumns: string[] = ['nomeFiltro', 'select'];
  dataSource = new MatTableDataSource<Filtro>(this.lstFiltro);
  selection = new SelectionModel<Filtro>(true, []);

  displayedColumnsEdit: string[] = ['usuarioCriacao', 'responsavel', 'select'];
  dataSourceEdit = new MatTableDataSource<FiltroItem>(this.lstFiltroItemEditar);
  selectionEdit = new SelectionModel<FiltroItem>(true, []);

  displayedColumnsCriar: string[] = ['usuarioCriacao', 'responsavel', 'select'];
  dataSourceCriar = new MatTableDataSource<FiltroItem>(this.lstFiltroItemCriar);
  selectionCriar = new SelectionModel<FiltroItem>(true, []);

  closePopup(){
    this.dialogRef.close("");
  }

}
